import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CCAuthService } from '@heidelberg/control-center-frontend-integration/auth';
import { HdmuiUserProvider } from '@heidelberg/hdmui-angular';
import { map } from 'rxjs';
import { CCPersonOrganizationMembership } from '@heidelberg/control-center-frontend-integration/cc';

export function provideUserProvider(): HdmuiUserProvider {
    const ccAuthService = inject(CCAuthService);

    return {
        currentUser: toSignal(
            ccAuthService.currentSession$.pipe(
                map((session) => {
                    if (!session?.user) {
                        return null;
                    }
                    const orgId = session.activeMembership?.organizationId ?? '';
                    return {
                        id: session.user.id,
                        fullName: session.user.fullName,
                        avatarUrl: session.user.avatarUrl ?? undefined,
                        activeOrganizationId: orgId,
                        memberships:
                            session.user.memberships?.length > 0
                                ? session.user.memberships.map((m: CCPersonOrganizationMembership) => ({
                                      id: m.id,
                                      organization: {
                                          id: m.organizationId,
                                          name: `${m.organization.name}`,
                                          logoUrl: m.organization.logoUrl ?? undefined,
                                      },
                                      roles: m.ccRoles,
                                  }))
                                : [],
                    };
                })
            ),
            { initialValue: null }
        ),
    };
}
